import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { applyLanguage, normalizeLanguage } from '../i18n';

/**
 * EN | RU language toggle. When logged in, PATCHes /auth/me preferredLanguage.
 */
export default function LanguageSelector({
  user,
  onUserLanguageChange,
  compact = false,
  style = {}
}) {
  const { t, i18n } = useTranslation('common');
  const [busy, setBusy] = useState(false);
  const current = normalizeLanguage(i18n.language || user?.preferredLanguage || 'en');

  async function setLang(nextRaw) {
    const next = normalizeLanguage(nextRaw);
    if (next === current || busy) return;
    setBusy(true);
    try {
      await applyLanguage(next);
      if (user?.id || user?._id) {
        const res = await fetch('/auth/me', {
          method: 'PATCH',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ preferredLanguage: next })
        });
        if (res.ok) {
          const j = await res.json().catch(() => null);
          if (onUserLanguageChange) {
            onUserLanguageChange(j?.user?.preferredLanguage || next);
          }
        }
      }
    } catch (_) {
      // keep UI language even if save fails
    } finally {
      setBusy(false);
    }
  }

  const btn = (code, label) => (
    <button
      type="button"
      className="sft-btn ghost"
      disabled={busy}
      aria-pressed={current === code}
      onClick={() => setLang(code)}
      style={{
        padding: compact ? '4px 8px' : '6px 10px',
        fontSize: compact ? 12 : 13,
        fontWeight: current === code ? 700 : 400,
        opacity: current === code ? 1 : 0.7,
        minWidth: compact ? 36 : 44
      }}
    >
      {label}
    </button>
  );

  return (
    <div
      className="sft-lang-selector"
      role="group"
      aria-label={t('language')}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 4, ...style }}
    >
      {!compact && (
        <span className="sft-hint" style={{ fontSize: 12, marginRight: 4 }}>{t('language')}</span>
      )}
      {btn('en', 'EN')}
      <span className="sft-hint" aria-hidden="true">|</span>
      {btn('ru', 'RU')}
    </div>
  );
}
